export default {
    esNegocio(state) {
        return !!state.negocioGest;
    },
    esDirectorio(state) {
        return !!state.directorioGest;
    },
    esCentralizadoMapeoNeo(state, getters) {
        return getters.negocioGestObj.mapeoNeoRestaurante;
    },
    negocioGestObj(state, getters, rootState) {
        let slug = state.negocioGest;
        let a = rootState.negocios.negociosArray;
        let found = a.find(e => e.id == slug)
        if (!found || !slug) {
            found = {
                id: null,
                nombre: ''
            }
        }
        return found;
    },
    restGestObj(state, getters, rootState) {
        let slug = state.restauranteGest;
        let a = rootState.restaurantes.restaurantesArray;
        let found = a.find(e => e.id == slug)
        if (!found || !slug) {
            found = {
                id: null,
                nombre: ''
            }
        }
        return found;
    },
    restaurantesFiltradosNegocio(state) {
        const idFound = state.negocioFiltrarRestaurante;
        var res = [];
        state.restaurante
        state.restaurantesArray.forEach((e) => {

            if (e.negocio == idFound) {
                res.push(e);
            }
        })
        return res;
    },
    esDesarrollo(state) {
        return state.modoDesarrollo == 'desarrollo';
    },
    clientesFacturarSelect(state) {
        return state.clientesFacturar.map(c => {
            let aux = {
                id: c.id,
                negocio: c.modo === 'restaurante' ? c.negocio : c.id,
                modo: c.modo
            }
            return {
                value: aux,
                text: c.modo === 'restaurante' ? c.nombreNegocio + ' ' + c.nombre + " | " + c.modo : c.nombre + " | " + c.modo,

            }
        })
    }
}